import styled from 'styled-components'
import { ReactComponent as Pendencies } from '~/assets/images/ic_pendencia_cinza.svg';

export const Container = styled.div`
  background-color: #ffffff;
  display: flex;
  flex:1;
`
export const Main = styled.main`
  display:flex;
  flex:1;
  flex-direction: column;

`
export const Content = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
  align-self:center;

  header{
    opacity: 0.7;
    h3 {
      font-size: 22px;
      margin-bottom: 0px;
      margin-top: 3px;
    }
  }
`;
export const Scroll =styled.div`
  overflow-y: scroll;
  height:65vh;

  @media (max-width:770px){
    padding-bottom: 95px;
  }
`
export const PendIcon = styled(Pendencies)`
  width: 40px;
  float: left;
  margin-right: 10px;
`;


